import React, { memo, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { IShipment } from 'types/shipment'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { useTrackConversion } from 'apps/fleet-planner/hooks/useTrackConversion'
import { AuctionShipmentOpsRep } from 'apps/fleet-planner/types'
import { MarketplaceLoadDetailsModal } from './MarketplaceLoadDetailsModal'
import { OpsRepModal } from './OpsRepModal'

interface IMarketplaceLoadDetailsContainerProps {
  /**
   * The route of the component MarketplaceLoadDetailsContainer is being used.
   * Required so handlers such as closeMarketplaceLoadDetailsModalHandler know where to route back to.
   * @example 'book'
   */
  route: string
  onModalClose?: () => void
  onShipmentDecline?: (shipmentId: number) => void
  queryParams?: string
  /**
   * @default false
   */
  showMap?: boolean
}

export const MarketplaceLoadDetailsModalContainer = memo<IMarketplaceLoadDetailsContainerProps>(
  ({ onModalClose, onShipmentDecline, queryParams = '', route, showMap = false }) => {
    const history = useHistory()
    const {
      activeOpsRep,
      setActiveOpsRep,
      setActiveShipmentDetailsId,
      setShipmentDetails,
    } = useMarketplaceContext()
    const { clearTrackConversionData } = useTrackConversion()

    const [isOpsRepModalOpen, setIsOpsRepModalOpen] = useState<boolean>(false)

    const closeMarketplaceLoadDetailsModalHandler = () => {
      clearTrackConversionData()
      history.replace(`/${route}${queryParams}`)
      setActiveShipmentDetailsId(undefined)
      setShipmentDetails({} as IShipment)
      if (onModalClose) {
        onModalClose()
      }
    }

    const openOpsRepModalHandler = (opsRepUser?: AuctionShipmentOpsRep) => {
      if (opsRepUser) {
        setActiveOpsRep(opsRepUser)
      }
      setIsOpsRepModalOpen(true)
    }

    const closeOpsRepModalHandler = () => setIsOpsRepModalOpen(false)

    const { shipmentId } = useParams<{ shipmentId: string }>()
    const isMPLoadDetailsModalOpen = Boolean(shipmentId)

    return (
      <div>
        {isMPLoadDetailsModalOpen && (
          <MarketplaceLoadDetailsModal
            isOpen={isMPLoadDetailsModalOpen}
            route={route}
            onClose={closeMarketplaceLoadDetailsModalHandler}
            onContactClick={openOpsRepModalHandler}
            onDecline={onShipmentDecline}
            showMap={showMap}
          />
        )}
        {isOpsRepModalOpen && (
          <OpsRepModal
            isOpen={isOpsRepModalOpen}
            opsRep={activeOpsRep}
            onClose={closeOpsRepModalHandler}
          />
        )}
      </div>
    )
  }
)
